module.exports = __webpack_public_path__ + "img/system9-mini.ea4d1f3d.png";